import Form from 'components/Form'
import { useLoading } from 'hooks/loading'
import { useToast } from 'hooks/toast'
import api from 'services/api'
import { deleteEmptyFields } from 'utlis/deleteEmptyFields'
import { v4 as uuidv4 } from 'uuid'
import { IComposition, useMenuFoodContext } from '../../../../contexts'
import {
  apiCreateMenuFoodTemplates,
  apiUpdateMenuFoodTemplates
} from '../../../../domain/api'
import { FormAddNewItem } from '../FormAddNewItem'

type IsOpenInModalProps = {
  idParent: number
  handleOnClose: () => void
}

type TypesFormProps = {
  isOpenInModal?: false | IsOpenInModalProps
  initialValues?: IMenuFoodData & {
    idUpdate: number
  }
  menuFoodId?: number
  actualMenuFoodDish?: number
  typeForm: 'create' | 'update'
  weekDay: string
  weekDayLabel: string
  week: number
}

export const FormAddItem = ({
  isOpenInModal,
  typeForm,
  menuFoodId,
  actualMenuFoodDish,
  weekDay,
  weekDayLabel,
  week
}: TypesFormProps): JSX.Element => {
  const { addToast } = useToast()
  const { checkActualErrors, templateComposition, setTemplateComposition } =
    useMenuFoodContext()

  const formAddNewItem = FormAddNewItem({
    typeForm,
    weekDay,
    weekDayLabel,
    week
  })

  const { activeLoading, disableLoading, loading } = useLoading()

  const onSubmitForm = async (data: { composition: IComposition[] }) => {
    const hasItemError = checkActualErrors()

    if (hasItemError) {
      return
    }

    data = deleteEmptyFields(data)

    const dishes_info = templateComposition.map(dish => {
      return {
        dish_id: dish.dish_id,
        dish_amount: dish.dish_amount,
        is_default_dish: dish.is_default_dish,
        dish_name: dish.dish_name,
        dish_type_name: dish.dish_type_name,
        dish_type_id: dish.dish_type_id,
        portion: dish.portion
      }
    })

    if (templateComposition.some(({ dish_name }) => dish_name === undefined)) {
      addToast({
        type: 'error',
        title: 'Por favor preencha todos os campos',
        description:
          'Por favor preencha todos os campos. A seleção de um item é obrigatória.'
      })
      return
    }
    if (
      templateComposition.some(({ dish_name, dish_type_name }, index) => {
        return templateComposition.some(
          (newComp, actualIndex) =>
            newComp.dish_name === dish_name &&
            newComp.dish_type_name === dish_type_name &&
            index !== actualIndex
        )
      })
    ) {
      addToast({
        type: 'error',
        title: 'Por favor preencha todos os campos',
        description:
          'Não é possível o registro do mesmo item duplicado, por favor, remova o item duplicado.'
      })
      return
    }

    if (isOpenInModal) {
      const { handleOnClose } = isOpenInModal
      if (typeForm === 'update') {
        const dataUpdate = {
          dishes_info: JSON.stringify(dishes_info)
        }
        try {
          activeLoading()
          await api.put(
            apiUpdateMenuFoodTemplates(String(actualMenuFoodDish)),
            dataUpdate
          )
          disableLoading()
          setTemplateComposition([
            {
              id: uuidv4(),
              dish_id: undefined,
              dish_type_id: undefined,
              dish_amount: 1,
              dish_name: undefined,
              is_default_dish: undefined,
              dish_type_name: undefined,
              portion: undefined,
              week_day: undefined,
              week: undefined
            }
          ])
          handleOnClose()
          addToast({
            type: 'success',
            title: 'Registro atualizado',
            description: 'Registro alterado com sucesso'
          })
        } catch (err: any) {
          disableLoading()

          console.log(err.response.data)
          handleOnClose()
          addToast({
            type: 'error',
            title: 'Erro ao atualizar o registro',
            description:
              'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
          })
        }
      } else {
        const newMenuDish = {
          menu_food_id: +menuFoodId,
          dishes_info: JSON.stringify(dishes_info),
          week_day: weekDay,
          week
        }

        try {
          activeLoading()
          await api.post(apiCreateMenuFoodTemplates(), newMenuDish)
          disableLoading()
          handleOnClose()
          addToast({
            type: 'success',
            title: 'Registro atualizado',
            description: 'Registro criado com sucesso'
          })
        } catch (err: any) {
          disableLoading()
          handleOnClose()
          addToast({
            type: 'error',
            title: 'Erro ao atualizar o registro',
            description:
              'Ocorreu um erro ao fazer a atualização, por favor, tente novamente.'
          })
        }
      }
    }
  }
  return (
    <Form onSubmit={onSubmitForm} setReset>
      <div>{formAddNewItem}</div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-primary" type="submit" disabled={loading}>
          Salvar
        </button>
      </div>
    </Form>
  )
}
